module.exports = __webpack_public_path__ + "static/media/3playerRoomsPlayed_1_5.dad43935.png";